var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"text-center mt-4 mb-5"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('img',{attrs:{"width":"120","height":"39","src":require("@/assets/images/nyonyacooking.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }